import type { Error } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { FieldNameProp } from '@swf/core/types/Props';
import {
  getValidatorsForLicense,
  minLength as minLengthFactory,
  mustContainSpaceBetweenIntAndChar,
  noWhiteStartOrEnd
} from '@swf/core/utils/validators';

import useAutoFocusInput from '../../hooks/useAutoFocusIf';
import { address } from '../../validators/address';
import TextInput from '../TextInput/TextInput';

import {
  TXTCLI_Street_Address,
  TXTWCL_Please_enter_your_addressX,
  TXTWCL_Please_try_againX_This_doesnXt_ELL,
  TXTWCL_Please_try_againX_This_must_be_ELL,
  TXTWCL_The_address_you_have_entered_i_ELL_1
} from './Address.messages.json';

interface Props extends FieldNameProp {
  country: string;
  requiredMessage?: Error['message'];
  value?: string;
  autofocus?: boolean;
}

const maxLength = 80;
const minLength = 4;

const Address: React.FC<Props> = ({
  country,
  fieldName,
  requiredMessage = TXTWCL_Please_enter_your_addressX,
  value,
  autofocus = false
}) => {
  const site = useSelector(select.cms.getSiteId);
  const inputRef = useAutoFocusInput(autofocus);

  return (
    <TextInput
      id={fieldName}
      label={TXTCLI_Street_Address}
      maxLength={maxLength}
      autoComplete="off"
      value={value}
      validators={[
        noWhiteStartOrEnd,
        required(requiredMessage),
        mustContainSpaceBetweenIntAndChar(TXTWCL_The_address_you_have_entered_i_ELL_1),
        minLengthFactory(minLength, {
          ...TXTWCL_Please_try_againX_This_must_be_ELL,
          values: { 0: minLength }
        }),
        ...getValidatorsForLicense(site, 'address'),
        address(country, TXTWCL_Please_try_againX_This_doesnXt_ELL)
      ]}
      checkDisabled
      inputRef={inputRef}
    />
  );
};

export default Address;
